import React from "react";
import Layout from "./layout";
import { graphql } from "gatsby";
import SEO from "../partials/SEO";
import getOgImage from "../helpers/getOgImage";

export default function PrivacyPolicy({ pageContext, data }) {
  const { lang, menu } = pageContext;

  return (
    <Layout className="privacy-policy" lang={lang} menu={menu}>
      <div
        className="container pt-5 mt-3"
        dangerouslySetInnerHTML={{
          __html: data.wpPage.content,
        }}
      ></div>
    </Layout>
  );
}

export const query = graphql`
  query PrivacyPolicy($lang: String!) {
    wpPage(component: { eq: "page-privacy" }, language: { slug: { eq: $lang } }) {
      title
      content
      metaTitle
      metaDescription
      metaKeywords
    }
    ogImage: file(relativePath: { eq: "icon.png" }) {
      publicURL
    }
  }
`;

export const Head = ({ pageContext, data: { wpPage, ogImage } }) => (
  <>
    <SEO
      lang={pageContext.lang}
      {...wpPage}
      ogImage={getOgImage(ogImage)}
      ogTitle={wpPage?.metaTitle}
      ogDescription={wpPage?.metaDescription}
    />
  </>
);
